
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DoctorsList from "./doctorslist";
import imgToken1 from "./assets/imgtoken1.png";
import imgQueue1 from "./assets/imgqueue1.png";
import familyBb from "./assets/familybb.png";
import mission1 from "./assets/mission1.png";
import tt1 from "./assets/tt1.jpg";
import tt2 from "./assets/tt2.jpg";
import tt3 from "./assets/tt3.jpg";
import tt4 from "./assets/tt4.jpg";
import tokenlyv from "./assets/tokenlyv.mp4";
import Achievements from "./achivm";
import Reviews from "./reviews";
import CompactTracking from "./CompactTracking";

const Home = () => {
  const [user, setUser] = useState(null);

  // Get user from localStorage
  useEffect(() => {
    const stored = localStorage.getItem("tokenly_user");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
      } catch {
        setUser(null);
      }
    } else {
      setUser(null);
    }
  }, []);



  return (
    <>
      {/* Compact Tracking Box - shows when tokens are active - only for users (role_id = 6) */}
      {user?.roleId === 6 && <CompactTracking />}

      {/* Live Tracking Modal (UI only for now) */}
      <div
        className="modal fade"
        id="liveTrackingModal"
        tabIndex="-1"
        aria-labelledby="liveTrackingModalLabel"
        aria-hidden="true"
        data-bs-backdrop="true"
        data-bs-keyboard="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: "500px", marginTop: "60px" }}
        >
          <div
            className="modal-content border-0 shadow-lg"
            style={{
              borderRadius: "16px",
              overflow: "hidden",
              border: "2px solid var(--tokenly-primary)",
            }}
          >
            <div
              className="modal-header border-0 pb-2 pt-3"
              style={{
                background:
                  "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
                color: "white",
              }}
            >
              <div className="w-100">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="d-flex align-items-center">
                    <span className="pulse-dot me-2"></span>
                    <h6
                      className="modal-title fw-bold mb-0"
                      id="liveTrackingModalLabel"
                      style={{ fontSize: "0.95rem" }}
                    >
                      Live Tracking
                    </h6>
                  </div>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ fontSize: "0.7rem" }}
                  ></button>
                </div>
                <div>
                  <small
                    className="fw-semibold"
                    id="trackDoctorName"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Dr. Name
                  </small>
                  <span className="text-white-50 mx-1">•</span>
                  <small
                    className="text-white-50"
                    id="trackSpecialty"
                    style={{ fontSize: "0.75rem" }}
                  >
                    Specialty
                  </small>
                </div>
              </div>
            </div>
            <div
              className="modal-body p-3"
              style={{
                background:
                  "linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)",
              }}
            >
              <div className="row g-3">
                <div className="col-6">
                  <div className="tracking-card text-center p-3 h-100">
                    <div
                      className="tracking-icon mb-2"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <i className="fa-solid fa-ticket fa-lg text-tokenly-primary"></i>
                    </div>
                    <small
                      className="text-muted d-block text-uppercase mb-1"
                      style={{ fontSize: "0.65rem", letterSpacing: "0.5px" }}
                    >
                      Your Token
                    </small>
                    <div
                      className="tracking-value text-tokenly-primary fw-bold"
                      id="trackYourToken"
                      style={{ fontSize: "1.5rem", lineHeight: 1.2 }}
                    >
                      --
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="tracking-card text-center p-3 h-100 bg-white">
                    <div
                      className="tracking-icon mb-2"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <i className="fa-solid fa-user-clock fa-lg text-success"></i>
                    </div>
                    <small
                      className="text-muted d-block text-uppercase mb-1"
                      style={{ fontSize: "0.65rem", letterSpacing: "0.5px" }}
                    >
                      Now Serving
                    </small>
                    <div
                      className="tracking-value text-dark fw-bold"
                      id="trackCurrentToken"
                      style={{ fontSize: "1.5rem", lineHeight: 1.2 }}
                    >
                      --
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div
                    className="tracking-card text-center p-3"
                    style={{
                      background:
                        "linear-gradient(135deg, var(--tokenly-primary) 0%, #10b981 100%)",
                      color: "white",
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-center mb-1">
                      <i
                        className="fa-solid fa-stopwatch me-2"
                        style={{ fontSize: "0.9rem" }}
                      ></i>
                      <small
                        className="text-white-50 text-uppercase"
                        style={{ fontSize: "0.65rem", letterSpacing: "0.5px" }}
                      >
                        Wait Time
                      </small>
                    </div>
                    <div
                      className="tracking-value fw-bold"
                      id="trackWaitTime"
                      style={{
                        fontSize: "2rem",
                        color: "white",
                        lineHeight: 1.2,
                      }}
                    >
                      0
                    </div>
                    <small
                      className="text-white-50"
                      style={{ fontSize: "0.7rem" }}
                    >
                      Minutes
                    </small>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-info mt-3 mb-0 d-flex align-items-start py-2"
                style={{ borderRadius: "8px", fontSize: "0.75rem" }}
              >
                <i
                  className="fa-solid fa-info-circle me-2 mt-1"
                  style={{ fontSize: "0.7rem" }}
                ></i>
                <small className="mb-0">
                  You can close this window. Your token remains active.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* live tracking closed should be used after  */}

      <div id="main-content">
        {/* Hero Section Modernized */}
        <section className="hero-section-modern">
          <div
            id="heroCarousel"
            className="carousel slide carousel-fade"
            data-bs-ride="carousel"
            data-bs-interval="5000"
          >
            <div className="carousel-indicators">
              {[0, 1, 2].map(idx => (
                <button
                  key={idx}
                  type="button"
                  data-bs-target="#heroCarousel"
                  data-bs-slide-to={idx}
                  className={idx === 0 ? "active" : ""}
                  aria-current={idx === 0 ? "true" : "false"}
                  aria-label={`Slide ${idx + 1}`}
                ></button>
              ))}
            </div>

            <div className="carousel-inner">
              {/* Slide 1 */}
              <div className="carousel-item active hero-slide" style={{ backgroundImage: `url(${imgToken1})` }}>
                <div className="hero-overlay-dark"></div>
                <div className="container hero-content-row">
                  <div className="row align-items-center w-100">
                    <div className="col-lg-6 hero-text-column">
                      <h1 className="hero-title-main mb-4">
                        Skip the Line, <br /><span>Get Your Token</span>
                      </h1>
                      <p className="hero-description mb-5">
                        Secure your place in the queue digitally with Online Token Booking.
                        Book OPD Tokens online, skip the waiting room, and save time with our
                        Smart Digital Token System for Doctors and Patients.
                      </p>
                      <Link
                        to={user?.roleId === 3 || user?.roleId === 4 ? "/doctor-dashboard" : "/alldoctors"}
                        className="btn btn-tokenly-primary px-5 py-3 rounded-pill shadow-lg hover-lift"
                        style={{ backgroundColor: '#10b981', border: 'none', fontSize: '1.1rem' }}
                      >
                        {user?.roleId === 3 || user?.roleId === 4 ? "Go to Dashboard" : "Get your Token Now"}
                      </Link>
                    </div>
                    <div className="col-lg-6 d-none d-lg-block">
                      <div className="hero-vid-container">
                        <div className="hero-vid-wrapper">
                          <video autoPlay loop muted playsInline className="w-100">
                            <source src={tokenlyv} type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2 */}
              <div className="carousel-item hero-slide" style={{ backgroundImage: `url(${imgQueue1})` }}>
                <div className="hero-overlay-dark"></div>
                <div className="container hero-content-row">
                  <div className="row align-items-center w-100">
                    <div className="col-lg-6 hero-text-column">
                      <h1 className="hero-title-main mb-4">
                        Real-time <br /><span>Queue Tracking</span>
                      </h1>
                      <p className="hero-description mb-5">
                        Track your turn in real time with Live Token Status Tracking. No more
                        waiting in cramped clinic lobbies — Skip the Queue and know exactly
                        when your turn is coming.
                      </p>
                      <Link
                        to={user?.roleId === 3 || user?.roleId === 4 ? "/doctor-dashboard" : "/alldoctors"}
                        className="btn btn-tokenly-primary px-5 py-3 rounded-pill shadow-lg hover-lift"
                        style={{ backgroundColor: '#10b981', border: 'none', fontSize: '1.1rem' }}
                      >
                        {user?.roleId === 3 || user?.roleId === 4 ? "View Dashboard" : "Find Your Doctor"}
                      </Link>
                    </div>
                    <div className="col-lg-6 d-none d-lg-block">
                      <div className="hero-vid-container">
                        <div className="hero-vid-wrapper">
                          <video autoPlay loop muted playsInline className="w-100">
                            <source src={tokenlyv} type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 3 */}
              <div className="carousel-item hero-slide" style={{ backgroundImage: `url(${familyBb})` }}>
                <div className="hero-overlay-dark"></div>
                <div className="container hero-content-row">
                  <div className="row align-items-center w-100">
                    <div className="col-lg-6 hero-text-column">
                      <h1 className="hero-title-main mb-4">
                        Easy <br /><span>Family Booking</span>
                      </h1>
                      <p className="hero-description mb-5">
                        Book tokens for your entire family in one go — Appointment with
                        Doctor and Find Doctor made simple. Parcha Banao, Number Lagao,
                        aur token book karo, sab ek jagah.
                      </p>
                      <Link
                        to={user?.roleId === 3 || user?.roleId === 4 ? "/doctor-dashboard" : "/alldoctors"}
                        className="btn btn-tokenly-primary px-5 py-3 rounded-pill shadow-lg hover-lift"
                        style={{ backgroundColor: '#10b981', border: 'none', fontSize: '1.1rem' }}
                      >
                        {user?.roleId === 3 || user?.roleId === 4 ? "Manage Clinic" : "Start Booking"}
                      </Link>
                    </div>
                    <div className="col-lg-6 d-none d-lg-block">
                      <div className="hero-vid-container">
                        <div className="hero-vid-wrapper">
                          <video autoPlay loop muted playsInline className="w-100">
                            <source src={tokenlyv} type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Us section Refined */}
        <section id="about-us" className="about-section-modern">
          <div className="container px-4 px-md-3">
            <div className="row align-items-center gx-5">
              <div className="col-lg-6 order-2 order-lg-1">
                <div className="pe-lg-5">
                  <span className="about-badge">About Us</span>
                  <h2 className="display-5 fw-bold text-dark mb-4">
                    Revolutionizing Patient <br /><span>Queues Experience</span>
                  </h2>
                  <p className="lead text-secondary mb-5">
                    Tokenly is a Smart OPD and OPD Management System built with precision to
                    ensure a seamless digital experience. Streamlining healthcare appointment
                    management for doctors and patients, we bridge the gap between them with
                    Simple Patient Queue Management — making healthcare accessible and
                    stress-free.
                  </p>

                  <div className="row g-4 mb-5">
                    {[
                      { text: "OPD Management Software", icon: "fa-hospital" },
                      { text: "Skip the Waiting Room", icon: "fa-users-slash" },
                      { text: "Optimize doctors’ time", icon: "fa-user-md" },
                      { text: "Online Token System for Doctors and Patients", icon: "fa-qrcode" }
                    ].map((item, idx) => (
                      <div className="col-sm-6" key={idx}>
                        <div className="d-flex align-items-center gap-3">
                          <div className="bg-success bg-opacity-10 text-success p-2 rounded-3">
                            <i className={`fa-solid ${item.icon}`}></i>
                          </div>
                          <span className="fw-bold text-dark">{item.text}</span>
                        </div>
                      </div>
                    ))}
                  </div>

                  <Link
                    to="/about"
                    className="btn btn-tokenly-primary px-4 py-3 rounded-pill"
                    style={{ backgroundColor: '#10b981', border: 'none' }}
                  >
                    Explore Our Mission &rarr;
                  </Link>
                </div>
              </div>

              <div className="col-lg-6 order-1 order-lg-2 mb-5 mb-lg-0">
                <div className="about-img-wrapper">
                  <img
                    src={mission1}
                    alt="Hospital Reception"
                    className="img-fluid w-100"
                  />
                  <div className="position-absolute bottom-0 start-0 bg-white p-4 m-4 rounded-4 shadow-lg d-none d-md-block" style={{ maxWidth: '200px' }}>
                    <h5 className="fw-black mb-1">10k+</h5>
                    <p className="small text-muted mb-0">Patients served digitally this month</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Token Process Section Refined */}
        <section className="process-section">
          <div className="container">
            <div className="text-center mb-5">
              <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill fw-bold mb-3">WORKFLOW</span>
              <h2 className="display-5 fw-bold mb-3">How it Works</h2>
              <p className="lead text-muted mx-auto" style={{ maxWidth: '600px' }}>Our streamlined process ensures you spend less time in waiting rooms and more time with your doctor.</p>
            </div>

            <div className="process-grid">
              {[
                {
                  step: "01",
                  title: "Select Doctor",
                  desc: "Choose from our curated list of top specialists and select your time slot.",
                  img: tt1,
                  icon: "fa-user-doctor"
                },
                {
                  step: "02",
                  title: "Secure Payment",
                  desc: "Fast and secure online payments via UPI, cards, or digital wallets.",
                  img: tt2,
                  icon: "fa-credit-card"
                },
                {
                  step: "03",
                  title: "Get Token",
                  desc: "Instantly receive your digital token with a precise queue number.",
                  img: tt3,
                  icon: "fa-ticket"
                },
                {
                  step: "04",
                  title: "Easy Check-in",
                  desc: "Arrive at the clinic and show your token for a seamless consultation.",
                  img: tt4,
                  icon: "fa-hospital-user"
                }
              ].map((item, idx) => (
                <div key={idx} className="process-step-card">
                  <div className="process-step-num">{item.step}</div>
                  <div className="process-step-icon">
                    <i className={`fa-solid ${item.icon}`}></i>
                  </div>
                  <h3>{item.title}</h3>
                  <p className="text-secondary small mb-4">{item.desc}</p>
                  <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: '160px' }}>
                    <img src={item.img} alt={item.title} className="w-100 h-100 object-fit-cover" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Show DoctorsList for patients and logged-out users, hide only for doctors/staff (3/4) */}
        {(user?.roleId !== 3 && user?.roleId !== 4) && <DoctorsList />}

        {/* App Download Modern Section */}
        <section className="app-download-modern">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <h2 className="display-5 fw-bold mb-4">Experience Tokenly <br />on Your Phone</h2>
                <p className="lead mb-5 opacity-75">
                  Take control of your time. Our mobile app allows you to book tokens,
                  track your real-time status, and view your consultation history from anywhere.
                </p>

                <div className="d-flex flex-wrap gap-4">
                  <a href="https://play.google.com/store/apps/details?id=com.doctorplus4" target="_blank" rel="noopener noreferrer" className="app-btn-premium">
                    <i className="fa-brands fa-google-play fa-2x me-3"></i>
                    <div className="text-start">
                      <small className="d-block opacity-50" style={{ fontSize: '0.65rem' }}>GET IT ON</small>
                      <span className="fw-bold fs-5">Google Play</span>
                    </div>
                  </a>
                  <a href="https://apps.apple.com/in/app/tokenly/id6447931085"
                   target="_blank" rel="noopener noreferrer" className="app-btn-premium">
                    <i className="fa-brands fa-apple fa-2x me-3"></i>
                    <div className="text-start">
                      <small className="d-block opacity-50" style={{ fontSize: '0.65rem' }}>DOWNLOAD ON THE</small>
                      <span className="fw-bold fs-5">App Store</span>
                    </div>
                  </a>
                </div>

                <div className="mt-5 d-flex align-items-center gap-3">
                  <div className="text-warning">
                    {[1, 2, 3, 4, 5].map(i => <i key={i} className="fa-solid fa-star me-1"></i>)}
                  </div>
                  <span className="fw-bold">4.9/5 Rating by 10k+ Users</span>
                </div>
              </div>

              <div className="col-lg-6 px-lg-5">
                <div className="app-vid-box">
                  <div className="ratio ratio-16x9">
                    <video autoPlay loop muted playsInline className="w-100 h-100">
                      <source src={tokenlyv} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Modernized */}
        <section id="token-faq-section" className="py-5">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Common Questions</h2>
              <p className="lead text-muted">Everything you need to know about our digital queue system.</p>
            </div>

            <div className="faq-modern-container">
              {[
                { q: "Is a Token the same as a fixed time slot?", a: "No. A Token represents your position in the digital queue. It does not guarantee a specific time. Please reach the clinic 15 minutes before your estimated sequence number is expected to be called." },
                { q: "What happens if I miss my Token number?", a: "If you are not present when your number is called, your token may be skipped. You will need to generate a new token at the reception desk to re-enter the queue." },
                { q: "Can I book a token for an Emergency?", a: "No. This online token system is strictly for routine OPD consultations. For medical emergencies please proceed directly to the Emergency Room (ER)." },
                { q: "Do I pay online or at the clinic?", a: "The online form generates your queue number only. Consultation fees must be paid at the reception counter upon arrival to validate your token." }
              ].map((item, idx) => (
                <details key={idx} className="faq-modern-item">
                  <summary>
                    <span>{item.q}</span>
                    <i className="fa-solid fa-chevron-down"></i>
                  </summary>
                  <div className="faq-modern-content">
                    <p className="mb-0" style={{ color: '#000000' }}>{item.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <Achievements />
        <Reviews />
      </div>
    </>
  );
};

export default Home;
